import { getRestCall } from "../../../utils/rest-api-call";
import { API_URL, WORKSPACE_API_READ_URL } from "../../../config";
import { getUserProfile } from "../../../utils/state-utils/get-user-profile";
import { getAuthWithAppName } from "../../auth";
import { isManagerOnly } from "../../../utils/get-roles";

export const GET_ITEM_APPS_START = "GET_ITEM_APPS_START";
export const GET_ITEM_APPS_SUCCESS = "GET_ITEM_APPS_SUCCESS";
export const GET_ITEM_APPS_ERROR = "GET_ITEM_APPS_ERROR";
export const GET_WORKSPACE_START = "GET_WORKSPACE_START";
export const GET_WORKSPACE_SUCCESS = "GET_WORKSPACE_SUCCESS";
export const GET_WORKSPACE_ERROR = "GET_WORKSPACE_ERROR";

export const getItemApps = (itemId, userId) => async (dispatch, getState) => {
    dispatch({ type: GET_ITEM_APPS_START });

    try {
        const state = getState();
        const itemRoles = (state.user?.user?.roles ?? []).filter(r => r.resourceId === itemId);
        const loadWorkspace = itemRoles.length === 0 || !isManagerOnly(itemRoles);
        const auth = getAuthWithAppName(state.auth);
        const res = await getRestCall(
            `${API_URL}/services/${itemId}/app?loadWorkspace=${loadWorkspace}`,
            auth,
            {},
            dispatch,
            auth.refreshToken,
            getUserProfile(state),
            itemId,
            userId
        );
        dispatch({ type: GET_ITEM_APPS_SUCCESS, payload: res });
    } catch (e) {
        dispatch({ type: GET_ITEM_APPS_ERROR, error: e });
    }
};

export const getWorkspaceId = itemUuid => async (dispatch, getState) => {
    dispatch({ type: GET_WORKSPACE_START });
    try {
        const state = getState();
        const auth = getAuthWithAppName(state.auth);
        const res = await getRestCall(
            `${WORKSPACE_API_READ_URL}/api/v1/workspaces/getBy?ownerId=${itemUuid}&itemId=${itemUuid}`,
            auth,
            {},
            dispatch,
            auth.refreshToken,
            getUserProfile(state),
            itemUuid
        );
        dispatch({ type: GET_WORKSPACE_SUCCESS, payload: { workspaceId: res.id, itemId: itemUuid } });
    } catch (e) {
        dispatch({ type: GET_WORKSPACE_ERROR, error: e });
    }
};
